import { Injectable } from '@angular/core';
import AWS from 'aws-sdk';
import { environment } from '@environment/environment';
import { AwsBase } from './aws.base';
import { IStorage } from './interfaces/istorage.interface';
import { isArrayNotEmpty } from '@app/core/helpers/utils';
@Injectable({
    providedIn: 'root'
})
/**
 * aws s3 service
 */
export class S3Service extends AwsBase implements IStorage {

    private readonly bucket: string;
    private readonly s3: any
    constructor() {
        super();
        this.s3 = this.getS3();
        this.bucket = environment.aws.s3.bucket;
    }

    /**
     * list multipart
     * @param key 
     */
    getUploadId(key: string): Promise<any> {
        return new Promise((res: any, rej: any) => {
            this.s3.listMultipartUploads({
                Bucket: this.bucket,
                Prefix: key
            }, function (err: any, data: any) {
                if (err) {
                    rej(err);
                }
                else {
                    let uploadId = null;
                    if (data && isArrayNotEmpty(data.Uploads)) {
                        uploadId = data.Uploads[0].UploadId;
                    }
                    res(uploadId);
                }
            });
        })
    }

    /**
     * list parts
     * @param key 
     * @param uploadId 
     */
    listParts(key: string, uploadId: string): Promise<any> {
        return new Promise((res: any, rej: any) => {
            var params = {
                Bucket: this.bucket,
                Key: key,
                UploadId: uploadId,
            };
            this.s3.listParts(params, function (err, data) {
                if (err) {
                    rej(err);
                }
                else {
                    res(data.Parts);
                }
            });
        })
    }

    /**
     * complete multipart upload
     * @param key 
     * @param multipartMap 
     * @param uploadId 
     * @param cb 
     */
    completeMultipartUpload(key: string, multipartMap: any, uploadId: string, cb: (err: any, data: any) => void) {
        var params = {
            Bucket: this.bucket,
            Key: key,
            MultipartUpload: multipartMap,
            UploadId: uploadId
        };
        this.s3.completeMultipartUpload(params, cb);
    }

    /**
     * create multipart upload
     * @param key 
     * @param contentType 
     * @param cb 
     */
    createMultipartUpload(key: string, contentType: string, cb: (err: any, data: any) => void) {
        var params = {
            Bucket: this.bucket,
            Key: key,
            ContentType: contentType
        };
        this.s3.createMultipartUpload(params, cb)
    }
    /**
     * upload parts
     * @param file 
     * @param key 
     * @param partNumber 
     * @param uploadId 
     * @param cb 
     */
    uploadPart(file: any, key: string, partNumber: number, uploadId: string, cb: (err: any, data: any) => void) {
        var params = {
            Body: file,
            Bucket: this.bucket,
            Key: key,
            PartNumber: partNumber,
            UploadId: uploadId
        };
        this.s3.uploadPart(params, cb);
    }
    /**
     * abort multipart upload
     */
    abortMultipartUpload(uploadId: string, key: string, cb: (err: any, data: any) => void) {
        var params = {
            Bucket: this.bucket,
            Key: key,
            UploadId: uploadId
        };
        this.s3.abortMultipartUpload(params, cb);
    }

    /**
     * upload file 
     * @param key 
     * @param dataBuffer 
     * @returns 
     */
    uploadFile(key: string, dataBuffer: any): Promise<any> {
        return new Promise((res: any, rej: any) => {
            this.s3.upload({
                Bucket: this.bucket,
                Key: key,
                Body: dataBuffer
            }, function (err, data) {
                if (data) {
                    res(data);
                }
                else {
                    rej(err);
                }
            });
        });
    }

    /**
     * get signed url
     * @param key 
     * @returns 
     */
    getSignedUrl(key: string): Promise<string> {
        return new Promise((res: any, rej: any) => {
            this.s3.getSignedUrl({
                Bucket: this.bucket,
                Key: key,
            }, function (err, data) {
                if (data) {
                    res(data);
                }
                else {
                    rej(err);
                }
            });
        });
    }

    /**
     * upload file on s3
     * @param uploadId 
     * @param key 
     * @param body 
     * @returns 
     */
         upload(key: string, body:any):Promise<any> {
            return new Promise((res,rej)=>{
                var params = {
                    Bucket: this.bucket,
                    Key: key,
                    Body: body
                };
                this.s3.upload(params, function(err:any, data:any) {
                    console.log(err, data);
                    if(err){
                        rej(err)
                    }
                    else {
                        res(data);
                    }
                  });
            })
        }


}